<script>
  import Vue from 'vue';
  import AlertComponent from '@/components/AlertComponent.vue';
  import confirmDialog from '@/components/ConfirmDialog.vue';
  import AppPageContainer from '@/components/app/PageContainer.vue';
  import snackBar from '@/Mixins/snackBar.js';
  import SharedMixin from '@/Mixins/Shared';
  import SharedHelper from '@/Helpers/Shared';
  import UserMixin from '@/Mixins/BaseInformation/UserMixin.js';
  import EditUserHelper from '@/Helpers/BaseInformation/EditUserHelper.js';
  import EducationDegreeMixin from '@/Mixins/BaseInformation/EducationDegreeMixin';
  export default {
    inject: ['tableImg', 'tableTitleImage'],
    components: {
      AlertComponent,
      confirmDialog,
      AppPageContainer,
    },
    mixins: [snackBar, SharedMixin, UserMixin, SharedHelper, EditUserHelper, EducationDegreeMixin],
    created() {
      this.$root.$refs.EditUser = this;
    },
    mounted() {
      this.mounteLoding();
    },
    data() {
      return {};
    },
    methods: {
      mounte: function () {
        let currentDate = Vue.moment().format('YYYY/MM/DD');
        this.maxDate = currentDate;
        this.expireMinDate = currentDate;
        let aYearFromNow = new Date();
        aYearFromNow.setFullYear(aYearFromNow.getFullYear() + 10);
        let expireMaxDate = Vue.moment(aYearFromNow).format('YYYY/MM/DD');
        this.expireMaxDate = expireMaxDate;
        this.confimType = 'edit';
        this.userId = this.$route.params.id;
        this.getListOfEducationDegreesForOther();
        this.getUserFunction(Number(this.userId));
      },
      backToUsers: function () {
        this.$router.back();
      },
    },
  };
</script>
<template>
  <app-page-container title="ویرایش کاربر">
    <template v-slot:header>
      <v-col cols="1" class="mr-n11">
        <v-btn
          class="mx-2 mt-3"
          fab
          dark
          small
          color="darkColor"
          @click="backToUsers()"
          elevation="0"
        >
          <v-icon dark>mdi-arrow-right mdi-18px</v-icon>
        </v-btn>
      </v-col>
      <v-spacer></v-spacer>
    </template>
    <template v-slot:body>
      <v-row no-gutters class="background-main mx-2 mt-5">
        <v-col cols="12">
          <v-card height="75vh" elevation="0" class="card-width body-card">
            <v-card-text>
              <v-row>
                <v-col cols="4">
                  <v-text-field
                    label="نام*"
                    outlined
                    dense
                    v-model="editUserInfo.firstName"
                    prepend-inner-icon="mdi-account mdi-18px"
                    clearable
                    clear-icon="mdi-close-circle-outline"
                  ></v-text-field>
                </v-col>
                <v-col cols="4">
                  <v-text-field
                    label="نام خانوادگی*"
                    outlined
                    dense
                    v-model="editUserInfo.lastName"
                    prepend-inner-icon="mdi-account mdi-18px"
                    clearable
                    clear-icon="mdi-close-circle-outline"
                  ></v-text-field>
                </v-col>
                <v-col cols="4">
                  <v-text-field
                    label="نام کاربری*"
                    outlined
                    dense
                    v-model="editUserInfo.userName"
                    prepend-inner-icon="mdi-account mdi-18px"
                    clearable
                    clear-icon="mdi-close-circle-outline"
                  ></v-text-field>
                </v-col>
                <v-col cols="4">
                  <v-autocomplete
                    :items="genderItems"
                    no-data-text="اطلاعاتی وجود ندارد"
                    dense
                    outlined
                    item-text="title"
                    item-value="id"
                    v-model="editUserInfo.gender"
                    label="جنسیت"
                    autocomplete="off"
                    clearable
                    clear-icon="mdi-close-circle-outline"
                    prepend-inner-icon="mdi-human-male-female mdi-18px"
                  ></v-autocomplete>
                </v-col>
                <v-col cols="4">
                  <v-text-field
                    type="text"
                    outlined
                    id="user-brithDate"
                    ref="dateTimeAdd"
                    dense
                    clearable
                    @click:clear="clearBirthDate()"
                    clear-icon="mdi-close-circle-outline"
                    v-model="tempUserBrithDate"
                    @focus="showUserBrithDate = true"
                    @click="showUserBrithDate = true"
                    label="تاریخ تولد"
                    prepend-inner-icon="mdi-calendar-range mdi-18px"
                  >
                    <template slot="append">
                      <v-icon
                        @click="showUserBrithDate = true"
                        class="calender-background ml-n3 mt-n2"
                        color="white"
                      >
                        mdi-calendar-range mdi-18px
                      </v-icon>
                    </template>
                  </v-text-field>
                  <date-picker
                    :show="showUserBrithDate"
                    simple
                    :max="maxDate"
                    v-model="editUserInfo.birthDate"
                    :min="minDate"
                    @change="userBrithDateChange()"
                    :editable="true"
                    format="YYYY-MM-DD"
                    display-format="jYYYY/jMM/jDD"
                    custom-input="#userr1-brithDate"
                    @close="showUserBrithDate = false"
                  />
                </v-col>
                <v-col>
                  <v-text-field
                    label="کد ملی*"
                    outlined
                    maxlength="10"
                    @keypress="isNumber($event)"
                    dense
                    v-model="editUserInfo.nationalCode"
                    prepend-inner-icon="mdi-card-account-details mdi-18px"
                    clearable
                    clear-icon="mdi-close-circle-outline"
                  ></v-text-field>
                </v-col>
                <v-col cols="4">
                  <v-text-field
                    label="شماره همراه"
                    outlined
                    maxlength="11"
                    @keypress="isNumber($event)"
                    dense
                    v-model="editUserInfo.phoneNumber"
                    prepend-inner-icon="mdi-phone mdi-18px mdi-flip-h"
                    clearable
                    clear-icon="mdi-close-circle-outline"
                  ></v-text-field>
                </v-col>
                <v-col cols="4">
                  <v-autocomplete
                    :items="allEducationDegreesForOther"
                    no-data-text="اطلاعاتی وجود ندارد"
                    dense
                    outlined
                    item-text="title"
                    item-value="id"
                    label="مدرک تحصیلی"
                    v-model="editUserInfo.educationDegreeId"
                    autocomplete="off"
                    clearable
                    clear-icon="mdi-close-circle-outline"
                    prepend-inner-icon="mdi-book-open-page-variant mdi-18px"
                  ></v-autocomplete>
                </v-col>
                <v-col cols="4">
                  <v-text-field
                    type="text"
                    outlined
                    id="user-brithDate"
                    ref="dateTimeAdd"
                    dense
                    clearable
                    @click:clear="clearExpireDate()"
                    clear-icon="mdi-close-circle-outline"
                    v-model="tempUserExpireDate"
                    @focus="showUserExpireDate = true"
                    @click="showUserExpireDate = true"
                    label="تاریخ انقضای حساب کاربری"
                    prepend-inner-icon="mdi-calendar-range mdi-18px"
                  >
                    <template slot="append">
                      <v-icon
                        @click="showUserExpireDate = true"
                        class="calender-background ml-n3 mt-n2"
                        color="white"
                      >
                        mdi-calendar-range mdi-18px
                      </v-icon>
                    </template>
                  </v-text-field>
                  <date-picker
                    :show="showUserExpireDate"
                    simple
                    @change="userExpireDateChange()"
                    :editable="true"
                    :max="expireMaxDate"
                    :min="expireMinDate"
                    format="YYYY-MM-DD"
                    v-model="editUserInfo.expireDate"
                    display-format="jYYYY/jMM/jDD"
                    custom-input="#userr1-brithDate"
                    @close="showUserExpireDate = false"
                  />
                </v-col>
                <v-col cols="4">
                  <v-text-field
                    label="ایمیل"
                    outlined
                    dense
                    v-model="editUserInfo.emailAddress"
                    prepend-inner-icon="mdi-email mdi-18px"
                    clearable
                    clear-icon="mdi-close-circle-outline"
                  ></v-text-field>
                </v-col>
                <v-col cols="8">
                  <v-text-field
                    label="آدرس"
                    outlined
                    dense
                    v-model="editUserInfo.address"
                    prepend-inner-icon="mdi-map-marker mdi-18px"
                    clearable
                    clear-icon="mdi-close-circle-outline"
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row class="my-10">
                <v-col cols="4" class="mt-n8">
                  <v-checkbox
                    v-model="editUserInfo.usePasswordPolicy"
                    label="اعمال قوانین رمز عبور"
                  ></v-checkbox>
                </v-col>
                <v-col cols="4" class="mt-n8">
                  <v-checkbox
                    v-model="editUserInfo.forceTwoStepAuthentication"
                    label="استفاده از روش احراز هویت دو مرحله ای"
                  ></v-checkbox>
                </v-col>
                <v-col cols="4" class="mt-n8">
                  <v-checkbox
                    v-model="editUserInfo.forceChangePassword"
                    label="تغییر کلمه عبور در ورود بعدی"
                  ></v-checkbox>
                </v-col>
              </v-row>
              <v-row class="">
                <v-spacer></v-spacer>
                <v-col cols="1">
                  <v-btn
                    rounded
                    color="darkColor"
                    block
                    dark
                    @click="checkValdition()"
                    class="normal-letter-spacing"
                  >
                    ویرایش
                  </v-btn>
                </v-col>
                <v-col cols="1" class="ml-1">
                  <v-btn
                    color="darkColor"
                    outlined
                    block
                    rounded
                    class="normal-letter-spacing"
                    @click="backToUsers()"
                  >
                    انصراف
                  </v-btn>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </template>
    <template v-slot:append>
      <confirm-dialog ref="confirm">
        <v-row slot="action" no-gutters>
          <v-spacer></v-spacer>
          <v-btn
            color="darkColor"
            small
            ref="yes"
            rounded
            class="normal-letter-spacing px-12 py-4 ml-2"
            style="color: white"
            @click="confirmDialogConfirmFunction()"
            :disabled="disabelConfirm"
          >
            بله
          </v-btn>
          <v-btn
            small
            rounded
            text
            ref="no"
            class="normal-letter-spacing px-12 confirm-cancel-btn"
            @click="confirmDialogCancelFunction()"
          >
            خیر
          </v-btn>
        </v-row>
      </confirm-dialog>
      <alert-component
        ref="snackRef"
        :snakTimeOut="snakTimeOut"
        :snackColor="snackColor"
        :snackText="snackText"
        :snakIcon="snakIcon"
      ></alert-component>
    </template>
  </app-page-container>
  <!-- <div>
    
    <v-row no-gutters class="table-content">
      <v-col cols="12" class="mr-2">
        <v-img :src="tableImg.val">
          <v-row>
            <v-col cols="3">
              <v-img
                :src="tableTitleImage.val"
                contain
                max-height="14vh"
                max-width="27vh"
              >
                <v-row>
                  <v-col cols="1"></v-col>
                  <v-col class="header-title" cols="10">
                    <span class="header-title-content">ویرایش کاربر</span>
                  </v-col>
                  <v-spacer></v-spacer>
                </v-row>
              </v-img>
            </v-col>
            <v-col cols="1" class="mr-n13">
              <v-btn
                class="mx-2 mt-3 mr-n16"
                fab
                dark
                small
                color="darkColor"
                @click="backToUsers()"
                elevation="0"
              >
                <v-icon dark> mdi-arrow-right mdi-18px</v-icon>
              </v-btn>
            </v-col>
            <v-spacer></v-spacer>
          </v-row>
          <v-row no-gutters class="background-main mx-2 mt-3">
            <v-col cols="12">
              <v-card height="68vh" elevation="0" class="card-width body-card">
                <v-card-text>
                  <v-row>
                    <v-col cols="4">
                      <v-text-field
                        label="نام*"
                        outlined
                        dense
                        v-model="editUserInfo.firstName"
                        prepend-inner-icon="mdi-account mdi-18px"
                        clearable
                        clear-icon="mdi-close-circle-outline"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="4">
                      <v-text-field
                        label="نام خانوادگی*"
                        outlined
                        dense
                        v-model="editUserInfo.lastName"
                        prepend-inner-icon="mdi-account mdi-18px"
                        clearable
                        clear-icon="mdi-close-circle-outline"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="4">
                      <v-text-field
                        label="نام کاربری*"
                        outlined
                        dense
                        v-model="editUserInfo.userName"
                        prepend-inner-icon="mdi-account mdi-18px"
                        clearable
                        clear-icon="mdi-close-circle-outline"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="4">
                      <v-autocomplete
                        :items="genderItems"
                        no-data-text="اطلاعاتی وجود ندارد"
                        dense
                        outlined
                        item-text="title"
                        item-value="id"
                        v-model="editUserInfo.gender"
                        label="جنسیت"
                        autocomplete="off"
                        clearable
                        clear-icon="mdi-close-circle-outline"
                        prepend-inner-icon="mdi-human-male-female mdi-18px"
                      ></v-autocomplete>
                    </v-col>
                    <v-col cols="4">
                      <v-text-field
                        type="text"
                        outlined
                        id="user-brithDate"
                        ref="dateTimeAdd"
                        dense
                        clearable
                        @click:clear="clearBirthDate()"
                        clear-icon="mdi-close-circle-outline"
                        v-model="tempUserBrithDate"
                        @focus="showUserBrithDate = true"
                        @click="showUserBrithDate = true"
                        label="تاریخ تولد"
                        prepend-inner-icon="mdi-calendar-range mdi-18px"
                      >
                        <template slot="append"
                          ><v-icon
                            @click="showUserBrithDate = true"
                            class="calender-background ml-n3 mt-n2"
                            color="white"
                            >mdi-calendar-range mdi-18px</v-icon
                          >
                        </template>
                      </v-text-field>
                      <date-picker
                        :show="showUserBrithDate"
                        simple
                        :max="maxDate"
                        v-model="editUserInfo.birthDate"
                        :min="minDate"
                        @change="userBrithDateChange()"
                        :editable="true"
                        format="YYYY-MM-DD"
                        display-format="jYYYY/jMM/jDD"
                        custom-input="#userr1-brithDate"
                        @close="showUserBrithDate = false"
                      />
                    </v-col>
                    <v-col>
                      <v-text-field
                        label="کد ملی*"
                        outlined
                        maxlength="10"
                        @keypress="isNumber($event)"
                        dense
                        v-model="editUserInfo.nationalCode"
                        prepend-inner-icon="mdi-card-account-details mdi-18px"
                        clearable
                        clear-icon="mdi-close-circle-outline"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="4">
                      <v-text-field
                        label="شماره همراه"
                        outlined
                        maxlength="11"
                        @keypress="isNumber($event)"
                        dense
                        v-model="editUserInfo.phoneNumber"
                        prepend-inner-icon="mdi-phone mdi-18px mdi-flip-h"
                        clearable
                        clear-icon="mdi-close-circle-outline"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="4">
                      <v-autocomplete
                        :items="allEducationDegreesForOther"
                        no-data-text="اطلاعاتی وجود ندارد"
                        dense
                        outlined
                        item-text="title"
                        item-value="id"
                        label="مدرک تحصیلی"
                        v-model="editUserInfo.educationDegreeId"
                        autocomplete="off"
                        clearable
                        clear-icon="mdi-close-circle-outline"
                        prepend-inner-icon="mdi-book-open-page-variant mdi-18px"
                      ></v-autocomplete>
                    </v-col>
                    <v-col cols="4">
                      <v-text-field
                        type="text"
                        outlined
                        id="user-brithDate"
                        ref="dateTimeAdd"
                        dense
                        clearable
                        @click:clear="clearExpireDate()"
                        clear-icon="mdi-close-circle-outline"
                        v-model="tempUserExpireDate"
                        @focus="showUserExpireDate = true"
                        @click="showUserExpireDate = true"
                        label="تاریخ انقضای حساب کاربری"
                        prepend-inner-icon="mdi-calendar-range mdi-18px"
                      >
                        <template slot="append"
                          ><v-icon
                            @click="showUserExpireDate = true"
                            class="calender-background ml-n3 mt-n2"
                            color="white"
                            >mdi-calendar-range mdi-18px</v-icon
                          >
                        </template>
                      </v-text-field>
                      <date-picker
                        :show="showUserExpireDate"
                        simple
                        @change="userExpireDateChange()"
                        :editable="true"
                        :max="expireMaxDate"
                        :min="expireMinDate"
                        format="YYYY-MM-DD"
                        v-model="editUserInfo.expireDate"
                        display-format="jYYYY/jMM/jDD"
                        custom-input="#userr1-brithDate"
                        @close="showUserExpireDate = false"
                      />
                    </v-col>
                    <v-col cols="4">
                      <v-text-field
                        label="ایمیل"
                        outlined
                        dense
                        v-model="editUserInfo.emailAddress"
                        prepend-inner-icon="mdi-email mdi-18px"
                        clearable
                        clear-icon="mdi-close-circle-outline"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="8">
                      <v-text-field
                        label="آدرس"
                        outlined
                        dense
                        v-model="editUserInfo.address"
                        prepend-inner-icon="mdi-map-marker mdi-18px"
                        clearable
                        clear-icon="mdi-close-circle-outline"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="4" class="mt-n8">
                      <v-checkbox
                        v-model="editUserInfo.usePasswordPolicy"
                        label="اعمال قوانین رمز عبور"
                      ></v-checkbox>
                    </v-col>
                    <v-col cols="4" class="mt-n8">
                      <v-checkbox
                        v-model="editUserInfo.forceTwoStepAuthentication"
                        label="استفاده از روش احراز هویت دو مرحله ای"
                      ></v-checkbox>
                    </v-col>
                    <v-col cols="4" class="mt-n8">
                      <v-checkbox
                        v-model="editUserInfo.forceChangePassword"
                        label="تغییر کلمه عبور در ورود بعدی"
                      ></v-checkbox>
                    </v-col>
                  </v-row>
                  <v-row class="mt-10">
                    <v-spacer></v-spacer>
                    <v-col cols="1"
                      ><v-btn
                        rounded
                        color="darkColor"
                        block
                        dark
                        @click="checkValdition()"
                        class="normal-letter-spacing"
                        >ویرایش</v-btn
                      ></v-col
                    >
                    <v-col cols="1" class="ml-1">
                      <v-btn
                        color="darkColor"
                        outlined
                        block
                        rounded
                        class="normal-letter-spacing"
                        @click="backToUsers()"
                        >انصراف</v-btn
                      >
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </v-img>
      </v-col>
    </v-row>
    
  </div> -->
</template>

<style scoped>
  .body-card {
    overflow-y: auto !important;
  }
  .confirm-cancel-btn {
    border: solid 1px var(--dark-color);
    padding-top: 13px;
    padding-bottom: 15px;
    color: var(--dark-color);
  }
  .calender-background {
    background: #79747e;
    padding-left: 12px;
    padding-right: 12px;
    padding-top: 12px;
    padding-bottom: 12px;
    border-top-left-radius: 5px !important;
    border-bottom-left-radius: 5px !important;
  }
  @media only screen and (min-width: 1280px) {
    .table-content {
      margin-top: 1vh !important;
    }
    .card-width {
      width: 99% !important;
      margin-right: 2vh !important;
    }
  }
  @media only screen and (min-width: 1366px) {
    .table-content {
      margin-top: 1vh !important;
    }
    .card-width {
      width: 98.5% !important;
      margin-right: 2vh !important;
    }
  }
  @media only screen and (min-width: 1536px) {
    .table-content {
      margin-top: 1vh !important;
    }
    .card-width {
      width: 99% !important;
      margin-right: 1vh !important;
    }
  }
</style>
